import { createSelector } from '@reduxjs/toolkit';
import { themeGroupings } from '../constants/themeGroupings';
import { selectClimateAttrById } from '../constants/climateAttrs';
import { selectHazardAttrById } from '../constants/hazardAttrs';
import { selectIsChartVisible } from '../ui/ui.selector';

const selectOptions = (state) => state.options;

export const selectTheme = createSelector(
  selectOptions,
  (options) => options.theme
);

export const selectThemeMarkdownFolderName = createSelector(
  selectOptions,
  (options) => themeGroupings.find((t) => t.id === options.theme).mdFolder
);

export const selectIsClimate = createSelector(
  selectOptions,
  (options) => options.dataType === 'climate'
);

export const selectAttributeId = createSelector(
  selectOptions,
  (options) => options[`${options.dataType}Option`]
);

export const selectAttributeInfo = createSelector(
  selectAttributeId,
  selectIsClimate,
  (id, isClimate) =>
    isClimate ? selectClimateAttrById(id) : selectHazardAttrById(id)
);

export const selectDateRange = createSelector(
  selectOptions,
  selectIsChartVisible,
  (options, isChartVisible) => {
    if (options.useAlternateData === 'hurricane' && isChartVisible) {
      return options.hurricaneRange;
    }

    return options[`${options.dataType}Range`];
  }
);

export const selectHazardMetric = createSelector(
  selectOptions,
  (options) => options.hazardMetric
);

export const selectUseAlternateData = createSelector(
  selectOptions,
  (options) => options.useAlternateData
);

export const selectUseHurricaneApi = createSelector(
  selectOptions,
  selectIsChartVisible,
  (options, isChartVisible) =>
    options.theme === 5 && options.useAlternateData && isChartVisible
);